import { register } from '../../../../Javascript/Utils.js'

const componentPrefix = 'oHeaderHamburger-'
const drawerPrefix = 'oHeaderMenuDrawer-'

const Hamburger = el => {
  const darkOpacityLayer = renderDarkOpacityLayer()
  const dOLparent = document.querySelector('body')
  const MenuDrawer = document.querySelector('.oHeaderMenuDrawer')

  el.addEventListener('click', () => {
    toggleAllHamburger()
    toggleMenuDrawer(MenuDrawer, darkOpacityLayer, dOLparent)
  })

  el.addEventListener('transitionend', () => {
    if (el.classList.contains(`${componentPrefix}-active`)) {
      // console.log(!dOLparent.classList.contains('has-darkOpacityLayer'));
      if (!dOLparent.classList.contains('has-darkOpacityLayer')) {
        dOLparent.classList.add('has-darkOpacityLayer')
        dOLparent.appendChild(darkOpacityLayer)
      }
    }
  })

  darkOpacityLayer.addEventListener('click', () => {
    toggleAllHamburger()
    toggleMenuDrawer(MenuDrawer, darkOpacityLayer, dOLparent)
  })
}

const renderDarkOpacityLayer = () => {
  const layer = document.createElement('div')
  layer.classList.add('darkOpacityLayer')
  return layer
}

const toggleAllHamburger = () => {
  const burgers = document.querySelectorAll('.oHeaderHamburger')
  burgers.forEach((el) => {
    if (el.classList.contains(`${componentPrefix}-active`)) {
      el.classList.remove(`${componentPrefix}-active`)
    } else {
      el.classList.add(`${componentPrefix}-active`)
    }
  })
}

const toggleMenuDrawer = (drawer, dOLayer, dOLayerParent) => {
  if (drawer) {
    if (drawer.classList.contains(`${drawerPrefix}-active`)) {
      drawer.classList.remove(`${drawerPrefix}-active`)
      dOLayerParent.classList.remove('has-darkOpacityLayer')
      // dOLayer.remove(); // wtf – this doesn't work
      document.querySelector('.darkOpacityLayer').remove()
    } else {
      drawer.classList.add(`${drawerPrefix}-active`)
    }
  } else {
    // styleGuide stuff
    if (dOLayerParent.classList.contains('has-darkOpacityLayer')) {
      dOLayerParent.classList.remove('has-darkOpacityLayer')
      document.querySelector('.darkOpacityLayer').remove()
    }
  }
}

register('Hamburger', Hamburger)
